// bloomingo-fe 의 Loading.tsx 와 동일한 Lottie 애니메이션을 그대로 사용.
import lottie, { type AnimationItem } from 'lottie-web';
import loadingData from '../assets/lottie/loading.json';

export function mountLoadingLottie(container: HTMLElement, size = 160): AnimationItem {
  container.innerHTML = '';
  const wrapper = document.createElement('div');
  wrapper.style.width = `${size}px`;
  wrapper.style.height = `${size}px`;
  container.appendChild(wrapper);
  return lottie.loadAnimation({
    container: wrapper,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: loadingData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });
}
